export default "__VITE_ASSET__Bkyh6O9c__"